import { type UserAssetsFilterType } from '../resources/yat-pages/page-items';

export const nft = () => ({
    public: {
        conversionRate: `/blockchain/pricing`,
        bids: `/collections/tokens/bids`,
        details: (currency = 'eth', contract: string, itemId: string) => `/${currency}/${contract}/${itemId}`,
        stats: (ownerId: string) => `/account/${ownerId}/user_asset_details`,
        owners: (currency = 'eth', contract: string, itemId: string) => `/${currency}/${contract}/${itemId}/owners`,
        ownerItems: (currency = 'eth', userId: string, filter: UserAssetsFilterType) =>
            filter === 'most_valuable'
                ? `/v2/yat_page/${userId}/collections/${filter}`
                : `/${currency}/${userId}/${filter}`,
        ownerCollectionItems: (currency = 'eth', contract: string, ownerId: string) =>
            `/${currency}/${contract}/owners/${ownerId}/items`,
        traits: (contract: string, itemId: string) => `/traits/explore/${contract}/${itemId}`,
        collectionAssets: (contract: string, itemId: string) => `/collections/${contract}/assets/${itemId}`,
        collectionDetails: (contract: string) => `/collections/details/${contract}`,
        collectionTokens: '/collections/tokens',
    },
});
